"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNThemes = VNThemes;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../components/utils");
var _styles = require("@material-ui/core/styles");
/**
 * 
 * @param {*} theme the theme to be used in MUI
 */
function VNThemes(props) {
  var theme = (0, _utils.getTheme)(props.theme);
  return /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, {
    theme: (0, _utils.getTheme)(props.theme)
  }, props.children);
}